import MModal from './MModal.vue';

MModal.install = (app) => {
  app.component('MModal', MModal);
};

export { MModal };
